import * as React from "react";
import Localization from "../../common/lang/Lang";
import { Link } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { ListBreadcrumb } from "./Data";
import {
  UserModel,
  CTranslatorState,
  TranslateLanguageModel,
} from "../../model";
import Swal from "sweetalert2";
import API from "../../common/AxoisClient";
import Lang from "../../common/lang/Lang";
import {
  ActionLink,
  EditLink,
  GeneratePermitLink,
  Breadcrumb,
  Icons,
  ExportButton,
  showNotification,
  ShowRecords,
  IState as CommonState,
  is_permit,
  CreateLink,
  Action,
} from "../../common/";
import { TranslatorInfo } from "./TranslatorInfo";
import _ from "lodash";
import { TranslatorActions } from "./TranslatorActions";
import { TranslatorContract } from "./TranslatorContract";
import {
  certifiedIcon,
  get_translator_gender_with_color,
  is_police_verified,
  is_vehicle,
  show_expensive_scale,
  translator_status,
  TranslatorStatuses,
  UserHelper,
} from "../../helpers/UserHelper";
import { SendOnlineTest } from "./popup/SendOnlineTest";
import { Qualification } from "./popup/Qualification";
import { Comments } from "./popup/Comments";
import { AboutTranslator } from "./popup/AboutTranslator";
import { TranslatorOnlineTestAnswer } from "./popup/TranslatorOnlineTestAnswer";
import { TranslatorCalling } from "./popup/TranslatorCalling";
import { Documents } from "./popup/Documents";
import TranslatorFilter from "./filter/TranslatorFilter";
import TranslatorFilterActive from "./filter/TranslatorFilterActive";
import TranslatorFilterApplicant from "./filter/TranslatorFilterApplicant";
import TranslatorFilterInactive from "./filter/TranslatorFilterInactive";
import { Stars } from "../../common/Stars";
import { list_key } from "../../helpers/OrderHelper";
import { commentsService, infoModalService } from "../../services";
import InfoModal from "./InfoModal";
import UserServices from "../../services/UserServices";
import CPRHistory from "./popup/CPRHistory";

declare var window: any;

export interface ContractModel {
  subject?: string;
  content?: string;
  contractContent?: string;
  translator_id?: number;
}

interface IState extends CommonState {
  UserData: Array<CTranslatorState>;
  ModalData?: UserModel;
  show?: boolean;
  contractPopup?: boolean;
  transID?: number;
  translatorName?: UserModel;
  contractData?: ContractModel;
  subject?: string;
  contractContent?: string;
  content?: string;
  TranslateCallingPopup?: boolean;
  TranslateCommentsPopup?: boolean;
  DocumentPopup?: boolean;
  vdeleted_translator?: string;
  translatorsType?: string;
  CPRPopup?: boolean
}
export const submitSpecialStatus = async (
  translator_id: number,
  callback: (res?: any) => void
) => {
  const res = await API.post(
    `users/translator/change-special-status/${translator_id}`,
    translator_id
  );
  showNotification("success", "Translator special status changed successfully");
  callback();
};

export class TranslatorsListing extends React.Component<
  RouteComponentProps,
  IState
> {
  state: IState;
  records: React.RefObject<ShowRecords> = React.createRef();
  componentWillMount() {
    const { path } = this.props.match;
    const translatorsType = path.split("/")[2];
    this.setState({
      vdeleted_translator: "0",
      translatorsType: translatorsType,
    });
  }

  shouldComponentUpdate(
    nextProps: Readonly<RouteComponentProps>,
    nextState: Readonly<IState>,
    nextContext: any
  ): boolean {
    if (this.props.match.path !== nextProps.match.path) {
      const translatorsType = nextProps.match.path.split("/")[2];
      this.setState({ translatorsType: translatorsType });
      return true;
    }
    return this.state !== nextState;
  }

  getTranslatorsType(path) {
    return path.split("/")[2];
  }

  showContent = (data: UserModel, index: number, callback?: any) => {
    let cols = [];
    if (this.state.vdeleted_translator === "0") {
      cols.push(
        <td>
          <div key={index}> {this.records.current.checkbox(data.id)} </div>
          {data.translator.worked_with_ministry ? <div data-toggle="tooltip" data-placement="top" title="Tolk har erfaring med at tolke for Udlændinge- og Integrationsministeriet, herunder Flygtningenævnet, Udlændingestyrelsen, SIRI og Udlændingestyrelsen"  style={{ position: 'relative', left: '-16px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="43" height="24" viewBox="0 0 430 242" fill="none">
              <path d="M352.106 228.912H254.606H157.107C156.493 228.912 156.063 229.403 156.063 229.955V239.957C156.063 240.57 156.554 241 157.107 241H254.606H352.106C352.719 241 353.149 240.509 353.149 239.957V229.955C353.21 229.342 352.719 228.912 352.106 228.912Z" fill="#0C9DC4"/>
              <path d="M347.809 104.23L343.452 105.273C340.507 83.4296 317.436 68.5807 273.687 90.9768C270.312 92.6948 266.324 94.781 261.66 94.5969V82.5092C270.803 79.8094 277.368 72.1395 277.368 62.997C277.368 53.1795 269.637 44.9574 259.329 42.9325V33.4219H267.612C267.612 33.4832 267.612 33.4832 267.612 33.4832C267.612 36.3058 269.698 38.6374 272.214 38.6374C274.791 38.6374 276.877 36.3058 276.877 33.4832C279.7 33.4832 282.032 31.397 282.032 28.8199C282.032 26.2429 279.761 24.1567 276.877 24.1567C276.877 21.2728 274.791 19.0025 272.214 19.0025C269.698 19.0025 267.612 21.2728 267.612 24.1567H259.329V16.18C262.274 16.18 264.606 14.0324 264.606 11.394C264.606 8.75551 262.274 6.6693 259.329 6.6693C259.329 3.72406 257.181 1.33105 254.543 1.33105C251.904 1.33105 249.757 3.72406 249.757 6.6693C246.811 6.6693 244.48 8.75551 244.48 11.394C244.48 13.971 246.811 16.18 249.757 16.18V24.1567H241.473C241.473 21.2728 239.387 19.0025 236.871 19.0025C234.294 19.0025 232.208 21.2728 232.208 24.1567C229.385 24.1567 227.054 26.2429 227.054 28.8199C227.054 31.397 229.324 33.4832 232.208 33.4832C232.208 36.3058 234.294 38.6374 236.871 38.6374C239.387 38.6374 241.473 36.3058 241.473 33.4832C241.473 33.4832 241.473 33.4832 241.473 33.4219H249.818V42.9325C239.51 44.896 231.778 53.1182 231.778 62.997C231.778 72.1395 238.405 79.8094 247.486 82.5092V94.5969C242.823 94.781 238.835 92.6948 235.46 90.9768C191.772 68.5807 168.701 83.3682 165.756 105.273L161.399 104.23C119.368 93.8606 111.576 127.117 120.043 140.984C123.418 146.568 130.843 154.668 138.083 163.565C135.076 165.221 132.622 169.516 137.163 173.259C140.721 176.205 155.57 186.574 156.061 208.541C156.061 209.154 156.552 209.707 157.227 209.707H254.665H352.104C352.717 209.707 353.27 209.154 353.27 208.541C353.76 186.574 368.609 176.205 372.168 173.259C376.709 169.516 374.254 165.221 371.248 163.565C378.427 154.606 385.851 146.568 389.287 140.984C397.694 127.117 389.901 93.8606 347.809 104.23ZM173.978 184.918C170.112 184.918 166.799 182.709 165.572 179.579H165.511C160.54 167.798 147.778 152.459 142.624 144.911C134.156 132.517 138.881 107.605 165.449 117.668C165.756 125.399 176.617 142.948 176.617 142.948L176.248 143.009C169.069 143.93 165.756 150.434 170.542 155.956C172.383 158.042 177.721 164.608 181.771 172.83C182.446 174.118 182.937 175.346 182.937 176.818C182.937 181.297 178.948 184.918 173.978 184.918ZM247.548 124.172C233.067 123.313 223.802 134.051 228.649 146.875C230.919 152.888 233.19 160.129 234.969 168.289C235.215 169.271 235.337 170.253 235.337 171.357C235.337 178.843 228.649 184.856 220.304 184.856C212.328 184.856 206.069 179.579 205.333 172.155C203.246 159.76 197.479 145.28 190.606 125.583C182.875 103.862 194.717 83.3682 231.349 102.021C237.853 105.335 243.559 106.685 247.548 106.685V124.172ZM318.602 125.583C311.668 145.28 305.962 159.76 303.875 172.155C303.139 179.579 296.88 184.856 288.904 184.856C280.559 184.856 273.871 178.843 273.871 171.357C273.871 170.253 274.055 169.271 274.239 168.289C276.018 160.067 278.289 152.888 280.559 146.875C285.406 134.051 276.202 123.313 261.66 124.172V106.685C265.649 106.685 271.355 105.335 277.859 102.021C314.491 83.4296 326.333 103.862 318.602 125.583ZM366.584 144.911C361.43 152.459 348.668 167.86 343.697 179.579C342.409 182.709 339.157 184.918 335.291 184.918C330.383 184.918 326.333 181.297 326.333 176.818C326.333 175.346 326.824 174.118 327.499 172.83C331.548 164.608 336.887 158.042 338.727 155.956C343.513 150.372 340.139 143.93 333.021 143.009L332.653 142.948C332.653 142.948 343.452 125.461 343.82 117.668C370.327 107.605 375.052 132.517 366.584 144.911Z" fill="#0C9DC4"/>
            </svg>
          </div>
          : null}
        </td>
      );
    }
    cols.push(
      ...[
        this.records.current.createdTd("id", () => {
          let status;
          let code = data.user_code !== null ? data.user_code : "--";
          if (data.status == 1) {
            status = (
              <p>
                <span
                  className={
                    "badge translator-type-badge translator-type-active w-6rem"
                  }
                >
                  {Lang.translator_active}
                </span>
              </p>
            );
          }
          if (data.status == 2) {
            const block_reason_div = data.block_reason ? (
              <>
                <br />
                <strong>Reason: </strong>
                {data.block_reason}
              </>
            ) : (
              <></>
            );
            status = (
              <p>
                <span
                  className={
                    "badge translator-type-badge translator-type-passive w-6rem"
                  }
                >
                  {Lang.inactive_passive}
                </span>
                {block_reason_div}
              </p>
            );
          }
          if (data.status == 3) {
            status = (
              <p>
                <span
                  className={
                    "badge translator-type-badge translator-type-applicant w-6rem"
                  }
                >
                  {Lang.applicant}
                </span>
              </p>
            );
          }
          if (data.status == 4) {
            const block_reason_div = data.block_reason ? (
              <>
                <br />
                <strong>Reason: </strong>
                {data.block_reason}
              </>
            ) : (
              <></>
            );
            status = (
              <p>
                <span
                  className={
                    "badge translator-type-badge translator-type-rejected w-6rem"
                  }
                >
                  {Lang.inactive_rejected}
                </span>
                {block_reason_div}
              </p>
            );
          }
          return (
            <div>
              <p>{code}</p>
              {status}
              {data.translator.special_status === 0 && (
                <div>
                  <a
                    href="javascript:void(0)"
                    className={"btn btn-default w-6rem"}
                    onClick={() =>
                      submitSpecialStatus(data.id, () => callback(this.records))
                    }
                    data-skin={"dark"}
                    title="Mark"
                  >
                    Mark
                  </a>
                </div>
              )}
              {data.translator.special_status === 1 && (
                <div>
                  <a
                    href="javascript:void(0)"
                    className={"btn btn-default w-6rem"}
                    onClick={() =>
                      submitSpecialStatus(data.id, () => callback(this.records))
                    }
                    data-skin={"dark"}
                    title="Unmark"
                  >
                    Afmærk
                  </a>
                  <span
                    className="badge badge-info special-status-badge w-6rem"
                    title={"Denne admin har reserveret denne tolk"}
                  >
                    {data.translator.special_status_update_user.name}
                  </span>
                  {/* <label style={{backgroundColor: 'orange','color':'white',padding:'10px', textAlign:'center'}}>{data.translator.special_status_update_user.name}</label> */}
                </div>
              )}
            </div>
          );
        }),
        this.records.current.createdTd("status", () => {
          return <div>{<TranslatorStatuses data={data} />}</div>;
        }),
        this.records.current.createdTd("name", () => {
          const { gender, color, icon } =
            get_translator_gender_with_color(data);
          let scale = show_expensive_scale(data.translator.exp_scale);
          return (
            <div style={{ width: "140px" }}>
              <GeneratePermitLink
                scope={"translator.index"}
                to={"#"}
                onClick={() => this.setState({ ModalData: data, show: true })}
                title={Lang.translator_info}
              >
                <p style={{ color: color }}>{data.name}</p>
              </GeneratePermitLink><br/><strong>{typeof data.distance === 'number' ? `(${data.distance.toFixed(2)} Km)` : null}</strong>
              {/* {scale} {certifiedIcon(data)} */}

              {/* <hr/> */}
              {/* {(data.translator.title!==null)?<span data-toggle="kt-tooltip" title="Title">{data.translator.title}</span>:''} */}
              {/* <hr/> */}
              {/* {!_.isEmpty(data.old_t_id) || data.old_t_id !== null && <p style={{color: '#0a6aa1'}}>Old System</p>} */}
              {/* {data.translator.registration_step < 4 && <p style={{color: '#0a6aa1'}}>{Lang.pending_profile}</p>} */}
              {/* {data.translator.is_sign_lang_translation === "1" && <i className="fa fa-sign-language" data-toggle="kt-tooltip" title="Sign Language Translation"/>} &nbsp; */}
              {/* {data.translator.send_online_test !== 2 && <i className="fa fa-question-circle" style={{color: '#0a6aa1'}} data-toggle="kt-tooltip" title="Online test is not taken"/>} &nbsp; */}
              {/* {
                      (_.isEmpty(data.translator.resume) || _.isEmpty(data.translator.children_certificate) || _.isEmpty(data.translator.criminal_record)) &&
                        <i className="fa fa-file-pdf"  style={{color: '#0a6aa1'}} data-toggle="kt-tooltip" title="Documents are not uploaded"/>
                    } */}
              {/* <hr/>
                    <i data-toggle="kt-tooltip" title={gender} style={{fontSize:'20px',color:color}} className={icon}/>&nbsp;
                    {is_vehicle(data)}&nbsp;
                    {is_police_verified(data)}
                    { data.translator.rating !== null && data.translator.rating > 0 &&
    					<>{' '+data.translator.rating+'.0 '}<i className="fa fa-star" style={{color: 'green',fontSize:'20px'}} /></>
                     } */}
            </div>
          );
        }),
        //this.records.current.createdTd("email", data.email),
        this.records.current.createdTd("email", () => {
          return (
            <>
              <span>{data.email}</span>
              <br />
              <>
                {data.translator_translation_type.map((item: any) => {
                  return (
                    <img
                      src={item.translation_type.small_icon}
                      data-toggle="kt-tooltip"
                      style={{ width: "20px", margin: "5px" }}
                      title={item.translation_type.title}
                    />
                  );
                })}
              </>
              <>
                {data.translator.is_sign_lang_translation === 1 && (
                  <span>
                    {" "}
                    |{" "}
                    <img
                      src={"/admin/assets/media/icons/service3.png"}
                      data-toggle="kt-tooltip"
                      style={{ width: "20px", margin: "5px" }}
                      title={Localization.sign_translation}
                    />
                  </span>
                )}
              </>
            </>
          );
        }),
        this.records.current.createdTd("mobile_no", () => {
          return <div style={{ width: "120px" }}>{data.mobile_no}</div>;
        }),
        this.records.current.createdTd("comments", () => {
          return (
            <div style={{ width: "120px" }}>
              <GeneratePermitLink
                className="kt-nav__link"
                scope={"translator.update"}
                to={"#"}
                onClick={() => {
                  commentsService.showPopup(data);
                }}
              >
                <p>{data.translator.comments} </p>
              </GeneratePermitLink>
            </div>
          );
        }),
        this.records.current.createdTd("about", () => {
          return (
            <div style={{ width: "120px" }}>
              <GeneratePermitLink
                className="kt-nav_link"
                scope={"translator.update"}
                to={"#"}
                onClick={() => {
                  infoModalService.showPopup(data.translator.about);
                }}
              >
                {(data.translator.about ?? "").length > 60
                  ? data.translator.about.slice(0, 60).concat("...")
                  : data.translator.about}
              </GeneratePermitLink>
            </div>
          );
        }),
        this.records.current.createdTd("address", () => {
          return (
            // <div style={{width:'200px'}}>{UserHelper.getAddress(data)} , { data.translator.locationtext}</div>
            <div style={{ width: "200px" }}>
              {UserHelper.getAddressRaw(data)}
            </div>
          );
        }),
        this.records.current.createdTd("language", () => {
          if (!_.isEmpty(data.translator_languages)) {
            return data.translator_languages.map((item: any, index) => {
              return (
                <div style={{ width: "180px" }}>
                  {!_.isEmpty(item.from_language) && (
                    <React.Fragment>
                      <img
                        src={
                          window.PUBLIC_URL +
                          "/admin/assets/flags/" +
                          _.lowerCase(
                            item.from_language.countries !== null &&
                              item.from_language.countries.iso
                          ) +
                          ".png"
                        }
                        className="img-flag"
                      />
                      &nbsp;
                      {item.from_language !== null &&
                        item.from_language.language_name}
                      <span className="exchangeIcon">
                        <i className="fas fa-exchange-alt" />
                      </span>
                    </React.Fragment>
                  )}
                  {!_.isEmpty(item.to_language) && (
                    <React.Fragment>
                      <img
                        src={
                          window.PUBLIC_URL +
                          "/admin/assets/flags/" +
                          _.lowerCase(
                            item.to_language.countries !== null &&
                              item.to_language.countries.iso
                          ) +
                          ".png"
                        }
                        className="img-flag"
                      />
                      &nbsp;
                      {item.to_language !== null &&
                        item.to_language.language_name}
                      <br />
                      <br />
                    </React.Fragment>
                  )}
                  {data.translator_languages &&
                    data.translator_languages.length > 0 &&
                    index == data.translator_languages.length - 1 && (
                      <div>
                        {data.translator.country !== null
                          ? data.translator.country.name
                          : ""}
                      </div>
                    )}
                </div>
              );
            });
          } else {
            return "---" + data.translator.country !== null
              ? data.translator.country.name
              : "";
          }
        }),
        this.records.current.createdTd("city", data.city),
        this.records.current.createdTd("created_at", () => {
          return (
            <div style={{ width: "200px" }}>
              {data.created_at} <br />
              <br />{" "}
              {data.registration_from !== null && (
                <span>
                  <b>{Lang.from} :</b> {data.registration_from} -{" "}
                  {data.created_by_user !== null
                    ? data.created_by_user.name
                    : ""}
                </span>
              )}
            </div>
          );
        }),
        this.records.current.createdTd(
          "account_no",
          data.translator.account_no
        ),
        this.records.current.createdTd(
          "bank_registration_no",
          data.translator.bank_registration_no
        ),
        this.records.current.createdTd(
          "agreed_income",
          data.translator.agreed_income === 1 ? Lang.yes : Lang.no
        ),
        this.records.current.createdTd("income", data.translator.income),
        this.records.current.createdTd(
          "driving_license",
          data.translator.driving_license === 1 ? Lang.yes : Lang.no
        ),
        this.records.current.createdTd(
          "is_km_pay",
          data.translator.is_km_pay === 1 ? Lang.yes : Lang.no
        ),
        this.records.current.createdTd(
          "how_many_km",
          data.translator.how_many_km
        ),
        this.records.current.createdTd(
          "how_much_pay",
          data.translator.how_much_pay
        ),
        this.records.current.createdTd(
          "is_certified",
          data.translator.is_certified === 1 ? Lang.yes : Lang.no
        ),
        this.records.current.createdTd(
          "is_transport_pay",
          data.translator.is_transport_pay === 1 ? Lang.yes : Lang.no
        ),
        this.records.current.createdTd(
          "hourly_pay",
          data.translator.hourly_pay
        ),
        this.records.current.createdTd(
          "own_vehicle",
          data.translator.own_vehicle === 1 ? Lang.yes : Lang.no
        ),
        this.records.current.createdTd(
          "police_verified",
          data.translator.police_verified === 1 ? Lang.yes : Lang.no
        ),
        this.records.current.createdTd("social_no", data.translator.social_no),
        this.records.current.createdTd("exp_scale", () => {
          if (data.translator.exp_scale === 1) {
            return <span>{Lang.average}</span>;
          }
          if (data.translator.exp_scale === 2) {
            return <span>{Lang.expensive}</span>;
          }
          if (data.translator.exp_scale === 3) {
            return <span>{Lang.very_expensive}</span>;
          }
        }),
        this.records.current.createdTd("push_agreement", () => {
          if (data.translator.push_agreement === 1) {
            return <span className={"badge badge-primary"}>{Lang.yes}</span>;
          }
          if (data.translator.push_agreement === 0) {
            return <span className={"badge badge-warning"}>{Lang.no}</span>;
          }
        }),
        this.records.current.createdTd("action", () => {
          if (data.deleted_at !== "" && data.deleted_at !== null) {
            return (
              <div>
                <ActionLink
                  scope={"translator.restore"}
                  to={"#"}
                  onClick={() => this.restoreTranslator(data.id)}
                  title={Lang.restore}
                >
                  <i className="fa fa-trash-restore" />
                </ActionLink>
              </div>
            );
          } else {
            const { sendConfirmationEmail, sendPasswordReset, verifyEmail, unblockLogin } = new UserServices(data)
            return (
              <div>
                <EditLink
                  scope={"translator.update"}
                  to={`${this.props.match.url}/info/${data.id}`}
                  title={Lang.edit_translator}
                />
                <TranslatorActions
                  translator_data={data}
                  SuperCustomer_data={data.id}
                  data_id={data.id}
                  showTPop={() => {
                    API.get("users/translator/get-email-data", { params: { slug: "translator_contract", translator_id: data.id }})
                      .then((response) => {
                        this.setState({
                          contractData: { ...response.data, contract: { ...response.data.contract, contract_pdf_file: data.translator.contract_pdf_file } },
                          contractPopup: true,
                          ModalData: data,
                        });
                      });
                  }}
                  showSPop={() => { this.setState({ TranslateCallingPopup: true,ModalData: data,});}}
                  showDPop={() => { this.setState({ DocumentPopup: true, ModalData: data });}}
                  sendConfirmationEmail={sendConfirmationEmail}
                  sendPasswordReset={sendPasswordReset}
                  verifyEmail={verifyEmail}
                  unblockLogin={unblockLogin}
                />
                <Action
                  onClick={() => this.setState({ CPRPopup: true, transID: data.translator.id })}
                >
                  <i className={Icons.activity_log}/>
                </Action>
              </div>
            );
          }
        }),
      ]
    );
    cols = _.compact(cols);
    return (
      <tr className="translator_row" key={list_key(data.id)}>
        {cols}
      </tr>
    );
  };

  restoreTranslator = (user_id: number) => {
    Swal.fire({
      title: Lang.is_sure,
      text: Lang.restore_confirm,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Ok",
    }).then((result) => {
      if (result.value) {
        API.post("users/translator/restore", { user_id: user_id }).then(
          (response) => {
            showNotification("success", Lang.restore_success);
            this.records.current.fetchData();
          }
        );
      }
    });
  };

  filterRecords = (data?: any) => {
    if (this.records && this.records.current !== null) {
      if (data !== undefined) {
        if (data.like.vdeleted_translator === "1") {
          this.setState({ vdeleted_translator: "1" });
        } else {
          this.setState({ vdeleted_translator: "0" });
        }
        this.records.current.setFormFields(data);
      } else {
        this.records.current.setFormFields();
      }
    }
  };

  filterComponent = (translatorsType, getResults) => {
    switch (translatorsType) {
      case "inactive":
        return <TranslatorFilterInactive getResults={getResults} />;

      case "active":
        return <TranslatorFilterActive getResults={getResults} />;

      case "applicants":
        return <TranslatorFilterApplicant getResults={getResults} />;

      default:
        return <TranslatorFilter getResults={getResults} />;
    }
  };

  actions = (actionType: string) => {
    let typeText;
    switch (actionType) {
      case "active":
        typeText = Lang.active_confirm;
        break;
      case "inactive":
        typeText = Lang.inactive_confirm;
        break;
      case "reject":
        typeText = Lang.reject_confirm;
        break;
      case "delete":
        typeText = Lang.delete_confirm;
        break;
    }
    if (
      typeText === Lang.inactive_confirm ||
      typeText === Lang.reject_confirm
    ) {
      Swal.fire({
        title: Lang.is_sure,
        text: typeText,
        html: '<input class="form-control" id="block_reason" placeholder="Enter reason here">',
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
        preConfirm: () => {
          if ($("#block_reason").val()) {
            // Handle return value
          } else {
            Swal.showValidationMessage("Please enter valid reason");
          }
        },
      }).then((result) => {
        if (result.value) {
          let ids: any = this.records.current.state.selected;
          API.post("users/translator/bulk-action", {
            ids,
            actionType: actionType,
            reason: $("#block_reason").val(),
          }).then((response) => {
            showNotification("success", response.data.message);
            this.records.current.fetchData();
          });
        } else {
          Swal.showValidationMessage("Please enter a valid reason");
        }
      });
    } else {
      Swal.fire({
        title: Lang.is_sure,
        text: typeText,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      }).then((result) => {
        if (result.value) {
          let ids: any = this.records.current.state.selected;
          API.post("users/translator/bulk-action", {
            ids,
            actionType: actionType,
          }).then((response) => {
            showNotification("success", response.data.message);
            this.records.current.fetchData();
          });
        }
      });
    }
  };

  render() {
    const actionButton = [
      {
        label: "Activate",
        class: "btn btn-sm btn-primary",
        onClick: () => this.actions("active"),
        show: is_permit("translator.update"),
      },
      {
        label: "Deactivate",
        class: "btn btn-sm btn-warning",
        onClick: () => this.actions("inactive"),
        show: is_permit("translator.update"),
      },
      {
        label: "Reject",
        class: "btn btn-sm btn-danger",
        onClick: () => this.actions("reject"),
        show: is_permit("translator.update"),
      },
      {
        label: "Delete",
        class: "btn btn-sm btn-danger",
        onClick: () => this.actions("delete"),
        show: is_permit("translator.delete"),
      },
    ];
    
    return (
      <div>
        <Breadcrumb data={ListBreadcrumb} />
        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
          <div className="kt-portlet kt-portlet--mobile">
            <div className="kt-portlet__head kt-portlet__head--lg">
              <div className="kt-portlet__head-label">
                <span className="kt-portlet__head-icon">
                  <i className="kt-font-brand flaticon-users" />
                </span>
                <h3 className="kt-portlet__head-title">
                  {Localization.translators}
                </h3>
              </div>
              <div className="kt-portlet__head-toolbar">
                <div className="kt-portlet__head-wrapper">
                  <div className="kt-portlet__head-actions">
                    <ExportButton
                      records={this.records}
                      fileName={Lang.exportTranslators}
                    />
                    &nbsp;
                    {/*<Link to={`/users/translators/create`}  className="btn btn-brand btn-elevate btn-icon-sm"> <i className={Icons.add}/> {Localization.add_new}</Link>*/}
                    <CreateLink
                      to={`/users/translators/create`}
                      scope={"translator.store"}
                    />
                  </div>
                </div>
              </div>
            </div>
            <form method={"get"} id={"filter_form"}>
              <div className="kt-portlet__body">
                <div className="kt-form kt-form--label-right kt-margin-t-20 kt-margin-b-10">
                  <div className="row align-items-center">
                    <div className="col-xl-12 order-2 order-xl-1">
                      {this.filterComponent(
                        this.state.translatorsType,
                        this.filterRecords
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <ShowRecords
                url={"users/translators"}
                showRecords={this.showContent}
                ref={this.records}
                showCheckbox={
                  this.state !== null && this.state.vdeleted_translator === "0"
                }
                isNeedAction={true}
                actionButtons={actionButton}
                callBack={() => {
                  window.KTApp.initTooltips();
                }}
                // translatorsType={this.state !== null && this.state.translatorsType}
                translatorsType={
                  (this.state !== null && this.state.translatorsType) ||
                  this.getTranslatorsType(this.props.match.path)
                }
              />
            </form>
          </div>
          {this.state !== null && (
            <TranslatorInfo
              show={this.state.show}
              onHide={() => this.setState({ show: false })}
              UserInfo={this.state.ModalData}
            />
          )}
          {this.state !== null && this.state.contractPopup && (
            <TranslatorContract
              show={this.state.contractPopup}
              onHide={() => this.setState({ contractPopup: false })}
              TransInfo={this.state.ModalData}
              ContractInfo={this.state.contractData}
            />
          )}
          {this.state !== null && this.state.TranslateCallingPopup && (
            <TranslatorCalling
              show={this.state.TranslateCallingPopup}
              onHide={() => this.setState({ TranslateCallingPopup: false })}
              transInfo={this.state.ModalData}
            />
          )}
          {this.state !== null && this.state.DocumentPopup && (
            <Documents
              show={this.state.DocumentPopup}
              onHide={() => this.setState({ DocumentPopup: false })}
              transInfo={this.state.ModalData}
            />
          )}
          {
            this.state !== null && this.state.CPRPopup && (
              <CPRHistory
                show={this.state.CPRPopup}
                closeModal={() => this.setState({ CPRPopup: false, transID: undefined })}
                translatorID={this.state.transID}
              />
            )
          }
          <SendOnlineTest />
          <Qualification />
          <Comments />
          <AboutTranslator />
          <TranslatorOnlineTestAnswer />
          <InfoModal />
        </div>
      </div>
    );
  }
}
